import * as React from 'react';
import { useState, useEffect } from 'react';
import { CssVarsProvider } from '@mui/joy/styles';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';

export default function TabsSegmentedControls({
    activeTab,
    setActiveTab,
    tabItems,
    setLoading,
    setSubActiveTab
}) {

    // useEffect(() => {
    //     const savedTab = sessionStorage.getItem("active-tab");
    //     if (savedTab !== null) {
    //         setActiveTab(parseInt(savedTab, 10));
    //     }
    // }, []);

    const handleTabChange = (event, newIndex) => {
        setActiveTab(newIndex);
        setSubActiveTab(newIndex);

        sessionStorage.setItem("active-tab", String(newIndex));
        sessionStorage.setItem("active-sub-type", tabItems[newIndex]?.type || "");

        setLoading(true);
        setTimeout(() => setLoading(false), 500);
    };

    return (
        <CssVarsProvider>
            <Tabs
                aria-label="tabs"
                value={activeTab}
                onChange={handleTabChange}
                sx={{
                    bgcolor: 'transparent',
                    display: 'flex',
                    justifyContent: 'flex-start',
                }}
            >
                <TabList
                    disableUnderline
                    sx={{
                        p: 1,
                        gap: 1,
                        borderRadius: '12px',
                        bgcolor: '#eeeeee',   // light grey background like screenshot
                        display: "inline-flex",
                        alignItems: "center",

                        [`& .${tabClasses.root}`]: {
                            borderRadius: '12px',
                            px: 2,
                            py: 1.2,
                            fontSize: '18px',
                            fontWeight: 500,
                            color: '#8a8a8a',
                            transition: "0.3s ease",
                        },

                        // Active tab styles
                        [`& .${tabClasses.root}[aria-selected="true"]`]: {
                            color: '#ffffff',
                            fontWeight: 600,
                            border: 0,
                            background: `linear-gradient(
                                180deg,
                                #75C4C5 0%,
                                #0D8196 100%
                            )`,
                            boxShadow: `
                                inset 0px 4px 12px rgba(255, 255, 255, 0.25),
                                0px 4px 10px rgba(0, 0, 0, 0.10)
                            `,
                        },
                    }}
                >
                    {tabItems.map((item, index) => (
                        <Tab disableIndicator key={index}>
                            {item?.name}
                        </Tab>
                    ))}
                </TabList>
            </Tabs>
        </CssVarsProvider>
    );
}
